var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentFail = function SvgPaymentFail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 200,
    fill: "none",
    viewBox: "0 0 192 211"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M129.047 45.845c-13.61 0-27.432-.552-40.376-4.158-12.7-3.54-24.362-10.362-34.756-18.271-6.821-5.165-12.993-9.258-21.845-8.64a40.38 40.38 0 0 0-23.566 9.16c-11.255 9.842-9.55 28.048-5.067 40.846 6.773 19.279 27.318 32.678 44.81 41.399 20.188 10.086 42.357 15.998 64.607 19.246 19.49 2.972 44.518 5.116 61.409-7.617 15.526-11.694 19.781-38.395 15.981-56.422a22.14 22.14 0 0 0-7.991-13.513c-10.898-7.974-27.155-2.647-39.401-2.388-4.548.163-9.16.358-13.805.358"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    d: "M180.986 22.847a1.592 1.592 0 1 0 0-3.184 1.592 1.592 0 0 0 0 3.184M112.349 11.51a1.592 1.592 0 1 0 0-3.183 1.592 1.592 0 0 0 0 3.184"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.624,
    d: "M48.781 114.708v6.983M45.291 118.2h6.984M149.77 17.747v7M146.277 21.255h6.984"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.624,
    d: "M86.559 111.265a48.726 48.726 0 0 0 71.608 8.413l19.376 5.863-7.423-21.682a48.72 48.72 0 0 0-3.936-48.782 48.72 48.72 0 0 0-44.321-20.755 48.72 48.72 0 0 0-44.207 53.2 48.7 48.7 0 0 0 8.903 23.726z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M143.028 86.22a3.216 3.216 0 1 0 0-6.432 3.216 3.216 0 0 0 0 6.433M127.517 86.22a3.215 3.215 0 1 0 0-6.43 3.215 3.215 0 0 0 0 6.43M112.024 86.22a3.216 3.216 0 1 0 0-6.432 3.216 3.216 0 0 0 0 6.433"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.624,
    d: "M102.445 78.116a48.726 48.726 0 0 1-67.856 11.369 44 44 0 0 1-3.752-2.956L11.46 92.425l7.422-21.699a48.724 48.724 0 1 1 83.562 7.39"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.624,
    d: "M48.979 59.292a16.436 16.436 0 0 1 28.13-.26"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M81.25 45.016a2.29 2.29 0 1 0 .001-4.58 2.29 2.29 0 0 0 0 4.58M44.968 45.016a2.29 2.29 0 1 0 0-4.58 2.29 2.29 0 0 0 0 4.58"
  })));
};
export default SvgPaymentFail;